import axios from 'axios'
import _ from 'lodash'
import moment from 'moment'

export const BILLING_INFO_FETCH = 'BILLING_INFO_FETCH'
export const BILLING_INFO_SET = 'BILLING_INFO_SET'
export const BILLING_INFO_UPDATE_PROP = 'BILLING_INFO_UPDATE_PROP'
export const BILLING_INFO_SET_IS_FETCHING = 'BILLING_INFO_SET_IS_FETCHING'

const state = {
    isLoadingBillingInfo: false,

    billingInfo: {
        plan: {}, // {'uuid': 'bbb', 'name': '190', 'price': 130},
        usage: {}, // {'invoices': 0},
        allowance: {}, // {'invoices': 190},
        modules: [], // 'SALES', 'PURCHASING'
        card: {}, // {'name': 'Main', 'lastFour': '4242', 'expiry': 1587011877, 'type': 'Visa'},
        subscription: {
            active: true,
            ended: false,
            cancelled: false,
            recurring: true,
            onTrial: false,
            onGracePeriod: false,
            hasIncompletePayment: false,
            trialEnds: 0
        },
        details: {
            name: '',
            email: '',
            tax: '',
            address: '',
            city: '',
            state: '',
            postCode: '',
            country: {} // {'code': 'AU', 'name': 'Australia'}
        },
        nextInvoice: null // {Date}
    }
}

const getters = {
    billingInfo: state => state.billingInfo || {},
    isLoadingBillingInfo: state => state.isLoadingBillingInfo,
    subscription: state => state.billingInfo.subscription || {},

    isActiveSubscription: (state, getters) => getters.subscription.active && getters.subscription.recurring && !getters.isAccountClosed,
    isFailedPayment: (state, getters) => getters.subscription.hasIncompletePayment,
    isAccountClosed: (state, getters) => (getters.subscription.ended || getters.subscription.cancelled) && !getters.subscription.onGracePeriod,

    isOnTrial: (state, getters) => !!getters.subscription.onTrial,

    isTrialEnded: (state, getters) => {
        return !getters.isActiveSubscription &&
            (getters.subscription.onTrial || (
                moment(getters.subscription.trialEnds).isValid() &&
                moment(getters.subscription.trialEnds).isSameOrBefore()))
    },

    isExpiredCard: state => {
        return !!(
            state.billingInfo.card &&
            state.billingInfo.card.expiry &&
            moment(state.billingInfo.card.expiry).isValid() &&
            moment(state.billingInfo.card.expiry).isBefore())
    },

    isPlanQuotaExceeded: state => {
        return !!(
            state.billingInfo.allowance &&
            state.billingInfo.allowance.invoices &&
            state.billingInfo.usage &&
            state.billingInfo.usage.invoices &&
            state.billingInfo.usage.invoices >= state.billingInfo.allowance.invoices)
    },

    hasOverdueNextInvoice: state => {
        return !!(
            state.billingInfo.nextInvoice &&
            state.billingInfo.nextInvoice &&
            moment(state.billingInfo.nextInvoice).isValid() &&
            moment(state.billingInfo.nextInvoice).isAfter()
        )
    }
}

const mutations = {
    [BILLING_INFO_SET]: (state, data) => {
        state.billingInfo = data
    },
    [BILLING_INFO_UPDATE_PROP]: (state, {path, data}) => {
        state.billingInfo = _.cloneDeep(_.set(state.billingInfo, path, data))
    },
    [BILLING_INFO_SET_IS_FETCHING]: (state, flag) => {
        state.isLoadingBillingInfo = flag
    }
}

const actions = {
    [BILLING_INFO_FETCH]: ({commit}) => {
        commit(BILLING_INFO_SET_IS_FETCHING, true)
        axios.get('teams/billing')
            .then(res => {
                commit(BILLING_INFO_SET, res.data || {})
            })
            .finally(() => {
                commit(BILLING_INFO_SET_IS_FETCHING, false)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
